import * as React from 'react';
import cx from 'clsx';

import styles from './style.module.scss';

function Input({
  className,
  type,
  error,
  prefix,
  ...props
}: React.ComponentProps<'input'> & { error?: string; prefix?: string }) {
  return (
    <div className="grid w-full items-center gap-1 relative">
      {prefix && <div className={styles['prefix']}>{prefix}</div>}
      <input
        type={type}
        data-slot="input"
        // data-invalid
        aria-invalid={!!error}
        data-prefix={prefix}
        className={cx(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-11 w-full min-w-0 rounded-md border bg-[#f7f7f7] px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          styles['input'],
          className,
        )}
        {...props}
        style={{
          ...props.style,
          paddingLeft: `calc(0.8rem + ${(prefix ?? '').length}ch)`,
        }}
      />
      <div className="text-red-500 min-h-[1em]">{error}</div>
    </div>
  );
}

export { Input };
